import { Provider } from '@angular/core';

import { CategoryDataHttpService } from './abstract';
import { CategoryDataHttpServiceImpl } from './category-data-http.service';

export const CategoryDataHttpProvider: Provider = {
	provide: CategoryDataHttpService,
	useClass: CategoryDataHttpServiceImpl,
};
